import { createContext, useContext, type ReactNode } from "react";

import { WHATSAPP } from "@/lib/itv/site";

const AgendamentoContext = createContext(WHATSAPP);

export function AgendamentoProvider({ link, children }: { link?: string | null; children: ReactNode }) {
  return (
    <AgendamentoContext.Provider value={link?.trim() || WHATSAPP}>
      {children}
    </AgendamentoContext.Provider>
  );
}

export function useAgendamentoLink() {
  return useContext(AgendamentoContext);
}